<script>
	import DefaultSlide from "./DefaultSlide.svelte";

	export let id;
	export let current;

	export let component;

	export let kicker;
	export let headline;
	export let text;
	export let height;
</script>

<section {id} class:lead={id === '0_lead'} class:current style:height={height || ""}>
	{#if component}
		<svelte:component this={component} {...$$props} />
	{:else}
		<DefaultSlide {kicker} {headline} {text} />
	{/if}
</section>

<style lang="scss">
	section {
		// margin: 0 auto;
		height: 110vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		&.lead {
			@media (max-width: $breakpoint-mobile) {
				align-items: start;
				transform: translateY(10%);
			}
		}
	}

	// section:first-of-type {
	// 	padding-top: 77vh;
	// }

	section:last-of-type {
		// padding-bottom: 80vh;
		// padding-bottom: 180vh;
	}
</style>
